"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = void 0;
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _isInteger = _interopRequireDefault(require("lodash/isInteger"));
var _CanvasObject2 = require("./CanvasObject");
var _Logger = require("../../../Utils/Logger");
var _HTML2Paper = _interopRequireDefault(require("../Utils/HTML2Paper"));
var _StyleParams = require("../Utils/StyleParams");
var _updateFontStyle = require("../Utils/updateFontStyle");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function set(target, property, value, receiver) { if (typeof Reflect !== "undefined" && Reflect.set) { set = Reflect.set; } else { set = function set(target, property, value, receiver) { var base = _superPropBase(target, property); var desc; if (base) { desc = Object.getOwnPropertyDescriptor(base, property); if (desc.set) { desc.set.call(receiver, value); return true; } else if (!desc.writable) { return false; } } desc = Object.getOwnPropertyDescriptor(receiver, property); if (desc) { if (!desc.writable) { return false; } desc.value = value; Object.defineProperty(receiver, property, desc); } else { _defineProperty(receiver, property, value); } return true; }; } return set(target, property, value, receiver); }
function _set(target, property, value, receiver, isStrict) { var s = set(target, property, value, receiver || target); if (!s && isStrict) { throw new TypeError('failed to set property'); } return value; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var logger = new _Logger.Logger('Text');
var Text = exports.Text = /*#__PURE__*/function (_CanvasObject) {
  _inherits(Text, _CanvasObject);
  var _super = _createSuper(Text);
  function Text(options) {
    var _this;
    _classCallCheck(this, Text);
    _this = _super.call(this);
    _defineProperty(_assertThisInitialized(_this), "_content", '');
    _defineProperty(_assertThisInitialized(_this), "_style", {});
    _defineProperty(_assertThisInitialized(_this), "_fontSize", 16);
    _defineProperty(_assertThisInitialized(_this), "_fontSizeMin", 8);
    _defineProperty(_assertThisInitialized(_this), "_isBulkName", false);
    _defineProperty(_assertThisInitialized(_this), "_textAlign", 'left');
    _defineProperty(_assertThisInitialized(_this), "_fontItem", {});
    /**
     * This method runs with a delay after the setScaling has been called.
     */
    _defineProperty(_assertThisInitialized(_this), "transformScalingToFontSize", (0, _debounce["default"])(function () {
      var scaling = _this.scaling;
      if (scaling !== 1) {
        _this._scaling = 1;
        var fontSize = Math.floor(_this._fontSize * scaling);
        if ((0, _isInteger["default"])(fontSize)) {
          _this.fontSize = fontSize;
        }
      }
    }, 500));
    _this.initOptions(options);
    if (options.content) {
      _this.content = options.content;
    }
    return _this;
  }
  _createClass(Text, [{
    key: "setScaling",
    value: function setScaling(scaling) {
      _get(_getPrototypeOf(Text.prototype), "setScaling", this).call(this, scaling);
      this.transformScalingToFontSize();
    }
  }, {
    key: "content",
    get: function get() {
      return this._content;
    },
    set: function set(value) {
      // create a wrapper element and assign it to the contentHTML, it does the rest
      var element = document.createElement('div');
      element.innerHTML = value;
      // if it has only one child then use that directly
      this.contentHTML = element.children.length === 1 ? element.firstChild : element;
    }
  }, {
    key: "contentHTML",
    get: function get() {
      return this._content;
    },
    set: function set(element) {
      var prevState = this.toObject();
      // store the outerHTML to get the default values as well
      this._content = element.outerHTML;
      this._style = _objectSpread(_objectSpread({}, (0, _StyleParams.collectStyleParams)(this._content)), this.getExplicitStyleParams());
      this.build();
      this.triggerChangeEvent(prevState);
    }
  }, {
    key: "style",
    get: function get() {
      return this._style;
    },
    set: function set(style) {
      //skipping explicit update as style is computed in contentHTML setter
    }
  }, {
    key: "fontSize",
    get: function get() {
      return this._fontSize;
    },
    set: function set(value) {
      var prevState = this.toObject();
      var fontSize = parseInt(value);
      if (!fontSize) {
        throw new Error('The given value is not a number!');
      }
      if (fontSize === this._fontSize) {
        return;
      }
      this._fontSize = Math.max(this._fontSizeMin, fontSize);
      this.build();
      this.triggerChangeEvent(prevState);
    }
  }, {
    key: "fontSizeMin",
    get: function get() {
      return this._fontSizeMin;
    },
    set: function set(value) {
      var prevState = this.toObject();
      this._fontSizeMin = value;
      // update fontSize to resize it if smaller than the minimum
      this.fontSize = this._fontSize;
      this.build();
      this.triggerChangeEvent(prevState);
    }
  }, {
    key: "build",
    value: function build() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var triggerChange = options.triggerChange;
      var converter = new _HTML2Paper["default"]();
      var canvas = this.canvas;
      // to do the build correctly for some browsers (eg. edge) the canvas has to be added to the DOM
      // test browser info: Microsoft Edge 44.18362.449.0
      var un = canvas && canvas.addToContainer();
      this.wrappedObject = converter.importHTML(this.content, this.wrappedObject, false, true, this.getExplicitStyleParams());
      un && canvas.removeFromContainer();
      if (triggerChange) {
        var prevState = this.toObject();
        this.triggerChangeEvent(prevState);
      }
    }

    /**
     * Triggers the build function if the canvas is available, so the content can be imported correctly
     * @param canvas
     */
  }, {
    key: "canvas",
    get:
    // the getter should be always overridden in pair with the setter
    // otherwise an access to this.canvas returns undefined (see Object.defineProperty for details)
    function get() {
      return this._canvas;
    },
    set: function set(canvas) {
      _set(_getPrototypeOf(Text.prototype), "canvas", canvas, this, true);
      this.build();
    }
  }, {
    key: "getExplicitStyleParams",
    value: function getExplicitStyleParams() {
      var fontSize = this.fontSize,
        textAlign = this.textAlign,
        fontItem = this.fontItem;
      return {
        fontSize: fontSize,
        textAlign: textAlign,
        fontItem: fontItem
      };
    }
  }, {
    key: "isBulkName",
    get: function get() {
      return this._isBulkName;
    },
    set: function set(value) {
      var prevState = this.toObject();
      this._isBulkName = value;
      this.triggerChangeEvent(prevState);
    }
  }, {
    key: "textAlign",
    get: function get() {
      return this._textAlign;
    },
    set: function set(value) {
      this._textAlign = value;
      this.build();
    }
  }, {
    key: "fontItem",
    get: function get() {
      return this._fontItem;
    },
    set: function set(fontItem) {
      this._fontItem = fontItem;
      this.content = (0, _updateFontStyle.updateFontStyle)(this.content, fontItem);
    }
  }, {
    key: "getState",
    value: function getState() {
      var content = this.content,
        fontSize = this.fontSize,
        fontSizeMin = this.fontSizeMin,
        textAlign = this.textAlign,
        fontItem = this.fontItem;
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(Text.prototype), "getState", this).call(this)), {}, {
        content: content,
        fontSize: fontSize,
        fontSizeMin: fontSizeMin,
        textAlign: textAlign,
        fontItem: fontItem
      });
    }
  }, {
    key: "toObject",
    value: function toObject() {
      var _get2;
      var content = this.content,
        style = this.style,
        fontSize = this.fontSize,
        fontSizeMin = this.fontSizeMin,
        isBulkName = this.isBulkName,
        textAlign = this.textAlign,
        fontItem = this.fontItem;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _objectSpread(_objectSpread({}, (_get2 = _get(_getPrototypeOf(Text.prototype), "toObject", this)).call.apply(_get2, [this].concat(args))), {}, {
        content: content,
        style: style,
        fontSize: fontSize,
        fontSizeMin: fontSizeMin,
        isBulkName: isBulkName,
        textAlign: textAlign,
        fontItem: fontItem
      });
    }
  }]);
  return Text;
}(_CanvasObject2.CanvasObject);
_defineProperty(Text, "type", 'Text');